import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { alertDetailsQuery } from '@/queries/alert-detail.query'

export const Route = createFileRoute('/_dashboard/site/$id/alerts/edit/$alertId/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(alertDetailsQuery(params.id, params.alertId))
  },
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.ALERT_CONFIGURATION) && !context.user?.hasPermission(Permission.EDIT_ALL)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  pendingComponent: PendingComponent,
})
